import { Capacitor } from "@capacitor/core";
import { parentApi } from "./api";

export const isNative = Capacitor.isNativePlatform();

export async function initNative() {
  if (!isNative) return;
  const { App } = await import("@capacitor/app");
  App.addListener("backButton", ({ canGoBack }) => (canGoBack ? window.history.back() : App.exitApp()));
  const { StatusBar, Style } = await import("@capacitor/status-bar");
  StatusBar.setStyle({ style: Style.Light }).catch(() => {});
  const { SplashScreen } = await import("@capacitor/splash-screen");
  SplashScreen.hide().catch(() => {});
}

// Push goes to parents only; requires Firebase config files in the native projects.
export async function registerParentPush() {
  if (!isNative || process.env.REACT_APP_PUSH_ENABLED !== "true") return;
  const { PushNotifications } = await import("@capacitor/push-notifications");
  let perm = await PushNotifications.checkPermissions();
  if (perm.receive === "prompt") perm = await PushNotifications.requestPermissions();
  if (perm.receive !== "granted") return;
  await PushNotifications.removeAllListeners();
  PushNotifications.addListener("registration", (t) => {
    localStorage.setItem("zunii_push_token", t.value);
    parentApi.post("/devices", { token: t.value, platform: Capacitor.getPlatform() }).catch(() => {});
  });
  await PushNotifications.register();
}

export async function unregisterParentPush() {
  const token = localStorage.getItem("zunii_push_token");
  if (!token) return;
  localStorage.removeItem("zunii_push_token");
  await parentApi.delete(`/devices/${encodeURIComponent(token)}`).catch(() => {});
}
